// The plan of the workspace for the sidebar meter (F8): "Get seats" on Free, the plan credits that are spent first.
// Loaded when the workspace or the place in view changes, and again when credits probably moved. A failure keeps
// what is on screen; a server without plans answers null and the meter stays as it was.
import { useEffect, useState } from "react";
import { keepIfSame } from "./quietRefresh.ts";
import type { BillingSource, PlanInfo } from "./sources.ts";

const EVENT = "filmsquare:credits";

export function usePlanInfo(billing: BillingSource, ws: string, placeKey: string): PlanInfo | null {
  // remembered with its workspace: a plan never shows under another workspace's name
  const [state, setState] = useState<{ ws: string; plan: PlanInfo | null } | null>(null);
  // biome-ignore lint/correctness/useExhaustiveDependencies: placeKey reloads when the route changes
  useEffect(() => {
    let live = true;
    const load = () =>
      billing.plan(ws, { seats: false }).then(
        (view) =>
          live &&
          setState((prev) => ({
            ws,
            plan: view ? (prev?.ws === ws && prev.plan ? keepIfSame(prev.plan, view.plan) : view.plan) : null,
          })),
        () => undefined,
      );
    void load();
    window.addEventListener(EVENT, load);
    return () => {
      live = false;
      window.removeEventListener(EVENT, load);
    };
  }, [billing, ws, placeKey]);
  return state?.ws === ws ? state.plan : null;
}
